import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { MapApiKey } from '../Authn/useServcieConfig';
import { MapState } from '../Components/Map/LiveAndReplay/Props';
import { PointsLayersMicrofences } from '../hooks/geomoby/useLiveMapLoader';

export const LAYER_GROUPS = atom<PointsLayersMicrofences | undefined>(undefined);
export const MAP_STATE = atom<MapState | undefined>(undefined);
export const MAP = atom(get => get(MAP_STATE)?.map);
export const ASSETS = atom(get => get(MAP_STATE)?.assets);

export type MapApiKeysRecord = Partial<Record<MapApiKey['provider'], string | undefined>>;
export const MAP_API_KEYS = atom<MapApiKeysRecord>({});
export const SHOW_TOOL_FINDER = atomWithStorage<boolean>('showToolFinder', false);
export const EMISSIONS_RATE_UNIT = atom<string | undefined>(undefined);
export const PRODUCTION_CAPACITY_UNIT = atom<string | undefined>(undefined);
